import React, { useState } from 'react';
import './CalculatorPage.css';

function BrandNameSuccessPredictor() {
  const [name, setName] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const predictSuccess = (inputName) => {
    // Placeholder for Brand Name Success Prediction logic
    // This is a highly simplified example; real prediction would be more complex.
    if (!inputName) return null;
    let sum = 0;
    const nameMap = {
      'A': 1, 'J': 1, 'S': 1,
      'B': 2, 'K': 2, 'T': 2,
      'C': 3, 'L': 3, 'U': 3,
      'D': 4, 'M': 4, 'V': 4,
      'E': 5, 'N': 5, 'W': 5,
      'F': 6, 'O': 6, 'X': 6,
      'G': 7, 'P': 7, 'Y': 7,
      'H': 8, 'Q': 8, 'Z': 8,
      'I': 9, 'R': 9
    };

    for (let i = 0; i < inputName.length; i++) {
      const char = inputName[i].toUpperCase();
      if (nameMap[char]) {
        sum += nameMap[char];
      }
    }

    while (sum > 9) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }

    if (sum === 1 || sum === 5 || sum === 6) {
      return `The numerological value of your brand name is ${sum}, which indicates a high potential for success.`;
    } else if (sum === 3 || sum === 9) {
      return `The numerological value of your brand name is ${sum}, indicating good potential with creative efforts.`;
    } else {
      return `The numerological value of your brand name is ${sum}. This number has a neutral influence on success.`;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    if (!name) {
      setError('Please enter a brand name.');
      return;
    }

    const calculated = predictSuccess(name);
    if (calculated === null) {
      setError('Invalid input. Please try again.');
    } else {
      setResult(calculated);
    }
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Brand Name Success Predictor",
    "description": "Predict the success of your brand name using numerology.",
    "url": "https://www.yourwebsite.com/brand-name-success-predictor",
    "potentialAction": {
      "@type": "PredictAction",
      "name": "Predict Brand Name Success",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/brand-name-success-predictor?name={name}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": "required name=name"
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Brand Name Success Predictor</h1>
      <p className="text-center">Enter your brand name to predict its numerological success.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="name">Brand Name:</label>
          <input
            type="text"
            id="name"
            className="form-control"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g., BrandX"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Predict Success</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Prediction:</h2>
          <p className="result-explanation">{result}</p>
        </div>
      )}
    </div>
  );
}

export default BrandNameSuccessPredictor;
